module.exports = __webpack_public_path__ + "static/img/win8.4cf9380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/win8.png
// module id = B3t0
// module chunks = 0